export default __webpack_public_path__ + "static/media/syzxs.5056bc3f.jpg";